import { useCallback } from "react";

let values = {};

const usePersistedState = (key) => {
  const setValue = useCallback(
    (value) => {
      values[key] = value;
    },
    [key]
  );

  const getValue = useCallback(() => {
    return values[key];
  }, [key]);

  const reset = useCallback(() => {
    values = {};
  }, []);

  return [getValue, setValue, reset];
};

export default usePersistedState;
